import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"Add Keywords\"}}\n\n<Settings::NwAddKeywords\n  @url={{this.url}}\n  @noAutoDiscover={{true}}\n  @isSettingsMode={{true}}\n/>")